import { AppConfigSettings, AppSettings } from '../../models';
import { ConfigProvider } from './config-provider';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LogService } from '../log/log.service';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class ConfigAppConfigProvider implements ConfigProvider {
  private readonly http: HttpClient = inject(HttpClient);
  public loadOrder = 2;

  public async getAppSettings(appSettings: AppSettings): Promise<AppSettings> {
    const fromConfig = await this.loadFromFile('./app-config.json');
    if (fromConfig === null) {
      LogService.error('Could not load internal config file');
      return appSettings;
    }

    appSettings.connection = {
      ...appSettings.connection,
      auth: fromConfig.authServerUrl,
      res: fromConfig.resourceServerUrl,
      clientId: fromConfig.clientId,
      clientSecret: fromConfig.clientSecret,
      redirectUri: fromConfig.redirectUri,
      postLogoutRedirectUri: fromConfig.postLogoutRedirectUri,
      autoClosePostLogoutPage: fromConfig.autoClosePostLogoutPage ?? false,
    };
    appSettings.dashboard = {
      ...appSettings.dashboard,
      menuTiles: fromConfig.menuTiles,
    };
    appSettings.customizing = {
      ...appSettings.customizing,
      menu: fromConfig?.menu,
      footerNavigation: {
        INIT: fromConfig?.footerNavigation?.INIT ?? [],
        SIGNED_IN: fromConfig?.footerNavigation?.SIGNED_IN ?? [],
      },
    };
    appSettings.tutorial = fromConfig.tutorial ?? appSettings.tutorial;
    appSettings.showDataPrivacyPage = fromConfig.showDataPrivacyPage ?? false;
    return appSettings;
  }

  private loadFromFile(url: string): Promise<AppConfigSettings | null> {
    return firstValueFrom(this.http.get<AppConfigSettings>(url)).catch(() => null);
  }
}
